// Дерево приложения: кэш запросов, канал (сайт или Mini App), плашка связи и маршруты.
// Роутер и кэш приходят снаружи: в браузере их создаёт main.tsx (поверх готовой страницы —
// с данными из неё), в тестах — тест. Модуль не трогает window при импорте (изменение seo).
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { RouterProvider, type createBrowserRouter } from "react-router";
import { ChannelProvider } from "../telegram/channel";
import { MiniAppSession } from "../telegram/MiniAppSession";
import type { TelegramWebApp } from "../telegram/telegramTypes";
import { ConnectionBanner } from "../ui/ConnectionBanner";

export type AppRouter = ReturnType<typeof createBrowserRouter>;

export function AppTree({
  router,
  queryClient,
  webApp = null,
}: {
  router: AppRouter;
  queryClient: QueryClient;
  webApp?: TelegramWebApp | null;
}) {
  // Mini App запущен на корне — открыть заказ, который назвал сервер; ссылка на конкретный экран
  // открывает его. Переход — новой записью истории: «назад» ведёт на развилку. Обещание
  // выполнится, когда экран заказа загружен, — до этого MiniAppSession держит «Входим…».
  async function openPathOnLaunch(path: string): Promise<void> {
    if (router.state.location.pathname === "/") await router.navigate(path);
  }

  const content = (
    <>
      <ConnectionBanner />
      <RouterProvider router={router} />
    </>
  );
  return (
    <QueryClientProvider client={queryClient}>
      <ChannelProvider webApp={webApp}>
        {webApp === null ? (
          content
        ) : (
          <MiniAppSession webApp={webApp} onOpenPath={openPathOnLaunch}>
            {content}
          </MiniAppSession>
        )}
      </ChannelProvider>
    </QueryClientProvider>
  );
}
